import Card from "./Card";

export default function CardList() {
  return (
    <div className="card-list overflow-y-scroll">
      <Card />
    </div>
  );
}
